import Vue from 'vue'
import Vuex from 'vuex'
import './../calculators'
import calculator from 'apps/bankrate-calculators/mortgages/ltv-loan-to-value-ratio-calculator'

Vue.use(Vuex)

new Vue({
  el: '#calculator',
  components: { calculator }
})
